import { useState } from "react"
import Block from "@/components/wrappers/block"
import { FilterControl } from "@/common/form/filter-control/filter-control"
import { useForm } from "react-hook-form"
import classNames from "classnames"
import Checkmark from "@/components/common/icons/checkmark"

export default function FlowerfieldMunicipalities({ block }) {
  const goal = block.attrs?.municipalities[0].meters * 1.2

  const headline = block.attrs?.headline ? block.attrs.headline : false

  const boxHeadline = block.attrs?.boxHeadline ? block.attrs.boxHeadline : false

  const boxText = block.attrs?.boxText ? block.attrs.boxText : false

  const municipalities = block.attrs?.municipalities ?? []

  const allMunicipalities = [...municipalities]
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((municipality) => {
      return {
        label: municipality.name,
        value: municipality.name
      }
    })

  const [selectedMunicipalities, setSelectedMunicipalities] = useState([])
  const [filterOpen, setFilterOpen] = useState(false)

  return (
    <Block block={block} className="mx-auto">
      <h2 className="mb-4 lg:mb-16 text-center">{headline}</h2>
      <MunicipalityCompare
        filterOpen={filterOpen}
        setFilterOpen={setFilterOpen}
        allMunicipalities={allMunicipalities}
        selectedMunicipalities={selectedMunicipalities}
        setSelectedMunicipalities={setSelectedMunicipalities}
        goal={goal}
        municipalitieStats={municipalities}
        boxHeadline={boxHeadline}
        boxText={boxText}
      />
    </Block>
  )
}

const MunicipalityCompare = ({
  filterOpen,
  setFilterOpen,
  allMunicipalities,
  selectedMunicipalities,
  setSelectedMunicipalities,
  municipalitieStats,
  goal,
  boxHeadline,
  boxText
}) => {
  const methods = useForm({
    defaultValues: {},
    mode: "onChange"
  })

  const { control, setValue } = methods

  return (
    <div className="bg-summer-green-25 p-10 lg:p-16 flex flex-wrap mb-10 lg:mb-20">
      <div className="w-full lg:w-3/4 text-center lg:text-left mb-4">
        <h2>{boxHeadline}</h2>
        <p>{boxText}</p>
      </div>

      <div className="w-full lg:w-1/4">
        <FilterControl
          key="municipalitiesController"
          isOpen={filterOpen}
          {...{
            control,
            label: "Kommuner",
            name: "municipalities",
            hierarchical: false,
            strings: {
              all: "Välj kommuner",
              singular: "kommun",
              plural: "kommuner"
            },
            options: allMunicipalities
          }}
          onSelect={(name, value) => {
            let newValues = [...selectedMunicipalities]
            let index = newValues.indexOf(value)
            if (index === -1) {
              newValues.push(value)
            } else {
              newValues.splice(index, 1)
            }
            setSelectedMunicipalities(newValues)
            setValue(name, newValues)
          }}
          onReset={(name) => {
            setSelectedMunicipalities([])
            setValue(name, [])
          }}
          selected={selectedMunicipalities}
          setOpen={(name) => {
            if (name == "municipalities" && filterOpen) {
              setFilterOpen(false)
            } else {
              setFilterOpen(true)
            }
          }}
        />
      </div>

      {selectedMunicipalities.length > 0 && (
        <div className="w-full mt-8">
          <SelectedMunicipalities
            municipalities={municipalitieStats}
            selectedMunicipalities={selectedMunicipalities}
            goal={goal}
          />
        </div>
      )}
    </div>
  )
}

function SelectedMunicipalities({
  municipalities,
  selectedMunicipalities,
  goal
}) {
  return (
    <>
      {municipalities
        .filter((municipality) => {
          if (
            selectedMunicipalities.length !== 0 &&
            selectedMunicipalities.includes(municipality.name)
          ) {
            return true
          }
        })
        .slice(0, 10)
        .map((municipality, index) => (
          <>
            <TopListItem
              key={index}
              name={municipality.name}
              meters={municipality.meters}
              index={index}
              selected={true}
              goal={goal}
            />
          </>
        ))}
    </>
  )
}

const TopListItem = ({ name, meters, index, goal, selected = false }) => {
  return (
    <div className="flex mb-10 items-center">
      <div
        className={classNames(
          "w-14 h-14 rounded-full flex justify-center items-center mr-4 font-serif font-bold",
          selected ? "bg-white" : "bg-summer-green-23"
        )}>
        {selected && <Checkmark className="w-4 h-4" />}
        {!selected && <>{index + 1}</>}
      </div>
      <div className="flex flex-1 flex-col">
        <div className="font-serif text-xl">
          <span className="font-bold">{name}</span>{" "}
          {(meters / 1000).toLocaleString("sv-SE", {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1
          })}{" "}
          km
        </div>
        <div
          style={{
            width: (meters / goal) * 100 + "%",
            backgroundImage: "url(/flowerfields/bar.svg)"
          }}
          className="h-6"></div>
      </div>
    </div>
  )
}
